import React from 'react';

import classes from './classes.module.css';

export default class NumberCard extends React.PureComponent {

    render = () => {
        const { className, style, number } = this.props;

        return <div className={`${classes.container} ${className || ''}`} style={style}>
            <div className={classes.topHalf} />
            <div className={classes.divider}>
                <div className={`${classes.joint} ${classes.left}`} />
                <div className={classes.line} />
                <div className={`${classes.joint} ${classes.right}`} />
            </div>
            <div className={`${classes.number} ${classes.flip}`} key={number}>{number}</div>
            <div className={classes.bottomHalf} />
        </div>;
    }

}